import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { i18nPlugin } from '@/i18n/i18n-vue'
import { navigatorDetector } from 'typesafe-i18n/detectors'
import { detectLocale } from '@/i18n/i18n-util'
import { loadLocaleAsync } from '@/i18n/i18n-util.async'

import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

import App from '@/App.vue';
import router from '@/router';

import { Inkline, components } from '@inkline/inkline';
import VCalendar from 'v-calendar';
import '@/css/variables/index.scss';
import '@inkline/inkline/css/utilities.scss';
import '@inkline/inkline/css/index.scss';
import 'v-calendar/style.css'
import '@/assets/scss/theme.scss'; // CUSTOM STYLES

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { all } from '@awesome.me/kit-f54a00038c/icons'

 // @ts-expect-error Not in control of these types
library.add(...all)

import { MEMBER_API, ApplicationApi, AuthenticationState, AUTH_STATE } from '@/api';
import { AppEnv, ENVIRONMENT } from '@/models/environment'
import { URL_HELPER, UrlHelper } from '@/helpers';
import log from 'loglevel';

const env = AppEnv.parse(import.meta.env);

log.setLevel(env.VITE_LOG_LEVEL)

const auth = new AuthenticationState()

const memberApi = new ApplicationApi(env.VITE_API_URL, auth)

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App)
  .component('font-awesome-icon', FontAwesomeIcon)
  .use(Inkline, { components })
  .use(pinia)
  .use(router)
  .use(VCalendar, {})
  .provide(MEMBER_API, memberApi)
  .provide(AUTH_STATE, auth)
  .provide(ENVIRONMENT, env)
  .provide(URL_HELPER, new UrlHelper(env))

const detectedLocale = detectLocale(navigatorDetector)

loadLocaleAsync('en')
  .then(() => loadLocaleAsync(detectedLocale))
  .then(() => {
    app.use(i18nPlugin, detectedLocale)
    .mount('#app');
})
